import { render, staticRenderFns } from "./MyCompanyUserTypesEdit.vue?vue&type=template&id=66e4cb87&"
import script from "./MyCompanyUserTypesEdit.vue?vue&type=script&lang=js&"
export * from "./MyCompanyUserTypesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports